import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b111c] text-gray-400">
      Loading…
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function RequireSuperadmin({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  // Admin access follows the (impersonated) user's role: a superadmin impersonating
  // another superadmin keeps access; impersonating a normal user does not.
  if (!user || user.role !== "superadmin") return <Navigate to="/account" replace />;
  return <>{children}</>;
}
